import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { SuperficieSobre } from 'src/app/models/superficieSobre.model';

@Component({
  selector: 'app-superficie-sobre',
  templateUrl: './superficie-sobre.component.html',
  styleUrls: ['./superficie-sobre.component.css']
})
export class SuperficieSobreComponent {



  @ViewChild('openModal') openModal: TemplateRef<any>;
  @ViewChild('openModalNODATA') openModalNODATA: TemplateRef<any>;



  public rows = [];
  public actualRow;
  public antecedente: SuperficieSobre;
  public formSobre;
  public temp_ant;
  public idForm;
  public form131;
  public form132;

  public form33 = false;
  public form35 = false;

  public form251;
  public form252;
  public form253;
  public form254;
  public form255;
  constructor(
    private dialog: MatDialog,

  ) {
    this.idForm = localStorage.getItem("form");

    if (this.idForm == "1-3.1") {
      this.form131 = true
    }
    if (this.idForm == "1-3.2") {
      this.form132 = true
    }


    if (this.idForm == "2-3.3") {
      this.form33 = true
    }
    if (this.idForm == "2-3.5") {
      this.form35 = true
    }

    if (this.idForm == "2-5.1") {
      this.form251 = true;
    }
    if (this.idForm == "2-5.2") {
      this.form252 = true;
    }
    if (this.idForm == "2-5.3") {
      this.form253 = true;
    }
    if (this.idForm == "2-5.4") {
      this.form254 = true;
    }
    if (this.idForm == "2-5.5") {
      this.form255 = true;
    }


    if (!JSON.parse(localStorage.getItem("superficieSobre"))) {
      localStorage.setItem("superficieSobre", JSON.stringify(this.rows));
    } else {
      this.rows = JSON.parse(localStorage.getItem("superficieSobre"));

    }


    this.antecedente = { nivelSub: "", utilSub: "", comunSub: "", totalSub: "", utilSubMod: "", comunSubMod: "", totalSubMod: "" };
    this.temp_ant = { nivelSub: "", utilSub: "", comunSub: "", totalSub: "", utilSubMod: "", comunSubMod: "", totalSubMod: "" };

    this.formSobre = new FormGroup({
      nivelSub: new FormControl(0),
      // utilSub: new FormControl('', [Validators.pattern(/^[0-9]\d*$/)]),
      utilSub: new FormControl(0),
      comunSub: new FormControl(0),
      totalSub: new FormControl(0),

      utilSubMod: new FormControl(0),
      comunSubMod: new FormControl(0),
      totalSubMod: new FormControl(0),
    })

  }


  add_superficieSobre() {

    this.actualRow = localStorage.getItem("superficieSobre");
    this.rows = JSON.parse(this.actualRow);

    if (!this.form251 && !this.form252 && !this.form253 && !this.form254 && !this.form255 && !this.form131 && !this.form132) {
      const { nivelSub, utilSub, comunSub, totalSub } = this.formSobre.value;

      if (
        nivelSub === null || nivelSub === undefined || nivelSub === '' ||
        utilSub === null || utilSub === undefined || utilSub === '' ||
        comunSub === null || comunSub === undefined || comunSub === '' ||
        totalSub === null || totalSub === undefined || totalSub === ''
      ) {
        this.dialog.open(this.openModalNODATA);
      } else {

        this.rows = this.rows.concat({
          nivelSub: this.formSobre.value.nivelSub,
          utilSub: this.formSobre.value.utilSub,
          comunSub: this.formSobre.value.comunSub,
          totalSub: this.formSobre.value.totalSub
        })


        localStorage.setItem("superficieSobre", JSON.stringify(this.rows));
        this.formSobre.reset();

      }
    }

    if (this.form251 || this.form252 || this.form253 || this.form254 || this.form255 || this.form131) {
      if (!this.formSobre.value.nivelSub || !this.formSobre.value.utilSub || !this.formSobre.value.comunSub || !this.formSobre.value.totalSub || !this.formSobre.value.utilSubMod || !this.formSobre.value.comunSubMod || !this.formSobre.value.totalSubMod) {
        this.dialog.open(this.openModalNODATA);

      } else {

        this.rows = this.rows.concat({
          nivelSub: this.formSobre.value.nivelSub,
          utilSub: this.formSobre.value.utilSub,
          comunSub: this.formSobre.value.comunSub,
          totalSub: this.formSobre.value.totalSub,

          utilSubMod: this.formSobre.value.utilSubMod,
          comunSubMod: this.formSobre.value.comunSubMod,
          totalSubMod: this.formSobre.value.totalSubMod
        })


        localStorage.setItem("superficieSobre", JSON.stringify(this.rows));
        this.formSobre.reset();

      }
    }


    if (this.form132) {
      if (!this.formSobre.value.nivelSub || !this.formSobre.value.utilSub || !this.formSobre.value.utilSubMod) {
        this.dialog.open(this.openModalNODATA);

      } else {

        this.rows = this.rows.concat({
          nivelSub: this.formSobre.value.nivelSub,
          utilSub: this.formSobre.value.utilSub,

          utilSubMod: this.formSobre.value.utilSubMod,
        })


        localStorage.setItem("superficieSobre", JSON.stringify(this.rows));
        this.formSobre.reset();

      }
    }
  }
  delete_superficieSobre(id) {
    for (let x = 0; x < this.rows.length; x++) {
      if (id == x) {
        this.rows.splice(x, 1);
        localStorage.setItem("superficieSobre", JSON.stringify(this.rows));
      }
    }
    this.actualRow = localStorage.getItem("superficieSobre");
    this.rows = JSON.parse(this.actualRow);
  }

  onChangeSelect(event) {
    let value = event.target.value;
  }

  get_superficieSobre(id) {
    for (let x = 0; x < this.rows.length; x++) {

      if (id == x) {
        this.temp_ant.nivelSub = this.rows[x].nivelSub;
        this.temp_ant.utilSub = this.rows[x].utilSub;
        this.temp_ant.comunSub = this.rows[x].comunSub;
        this.temp_ant.totalSub = this.rows[x].totalSub;

        this.dialog.open(this.openModal);

      }
    }
  }

  cleanData() {
    this.temp_ant = { nivelSub: 0, utilSub: 0, comunSub: 0, totalSub: 0, utilSubMod: 0, comunSubMod: 0, totalSubMod: 0 };

  }

  savesuperficieSobre() {
    this.dialog.closeAll();
    var id = this.temp_ant.numpermiso;
    for (let x = 0; x < this.rows.length; x++) {
      if (id == x) {
        this.rows.splice(x, 1);
        localStorage.setItem("superficieSobre", JSON.stringify(this.rows));

        if (!this.form251 && !this.form252 && !this.form253 && !this.form254 && !this.form255 && !this.form131 && !this.form132) {
          this.actualRow = localStorage.getItem("superficieSobre");
          this.rows = JSON.parse(this.actualRow);
          this.rows = this.rows.concat({
            nivelSub: this.temp_ant.nivelSub,
            utilSub: this.temp_ant.utilSub,
            comunSub: this.temp_ant.comunSub,
            totalSub: this.temp_ant.totalSub

          })
        }

        if (this.form251 || this.form252 || this.form253 || this.form254 || this.form255 || this.form131) {
          this.actualRow = localStorage.getItem("superficieSobre");
          this.rows = JSON.parse(this.actualRow);
          this.rows = this.rows.concat({
            nivelSub: this.temp_ant.nivelSub,
            utilSub: this.temp_ant.utilSub,
            comunSub: this.temp_ant.comunSub,
            totalSub: this.temp_ant.totalSub,

            utilSubMod: this.temp_ant.value.utilSubMod,
            comunSubMod: this.temp_ant.value.comunSubMod,
            totalSubMod: this.temp_ant.value.totalSubMod
          })

        }

        if (this.form132) {
          this.actualRow = localStorage.getItem("superficieSobre");
          this.rows = JSON.parse(this.actualRow);
          this.rows = this.rows.concat({
            nivelSub: this.temp_ant.nivelSub,
            utilSub: this.temp_ant.utilSub,

            utilSubMod: this.temp_ant.value.utilSubMod,
          })

        }
        localStorage.setItem("superficieSobre", JSON.stringify(this.rows));
        /*   this.temp_ant.reset() */
        this.dialog.closeAll();
      }
    }
  }
}
